module.exports = {
  rockers: {
    hat: {
      en: 'http://www.kangolstore.com/digi-marble-casual.html',
      jp: 'http://kangol.jp/store/products/detail.php?product_id=670'
    },
    disk: 'https://itunes.apple.com/us/album/king-davids-melody/id798750894'
  },
  ppu: {
    hat: {
      en: 'http://www.kangolstore.com/tropic-504-ventair-cap.html',
      jp: 'http://kangol.jp/store/products/detail.php?product_id=662'
    },
    disk: 'http://ppudc.highwire.com/product/tony-palkovic-born-with-a-desire-12'
  },
  'golf-channel': {
    hat: {
      en: 'http://www.kangolstore.com/marker-pen-reversible-bucket-hat.html',
      jp: 'http://kangol.jp/store/products/detail.php?product_id=713',
      kr: 'http://www.kangolkorea.com/product/detail.html?product_no=1701&cate_no=29&display_group=1'
    },
    disk: 'https://golfchannelrecordings.bandcamp.com/album/paradise-mice-life-subconscient-lamentation'
  },
  foundation: {
    hat: {
      en: 'http://www.kangolstore.com/tropic-bombin.html',
      jp: 'http://kangol.jp/store/products/detail.php?product_id=720',
      kr: 'http://www.kangolkorea.com/product/detail.html?product_no=1750&cate_no=29&display_group=1'
    },
    disk: 'https://itunes.apple.com/album/haemong-yang-haemongyang-ep/id593751526'
  },
  burger: {
    hat: {
      en: 'http://www.kangolstore.com/tropic-ventair-spacecap.html',
      jp: 'http://kangol.jp/store/products/detail.php?product_id=696'
    },
    disk: 'http://burgerrecords.11spot.com/lp/jaill-brain-cream-pre-order.html'
  },
  'stones-throw': {
    hat: {
      en: 'http://www.kangolstore.com/bermuda-casual.html',
      jp: 'http://kangol.jp/store/products/detail.php?product_id=668',
      kr: 'http://www.kangolkorea.com/product/detail.html?product_no=1812&cate_no=29&display_group=1'
    },
    disk: 'http://www.stonesthrow.com/store/album/mndsgn/yawn-zen'
  },
  workshop: {
    hat: {
      en: 'http://www.kangolstore.com/tropic-hardee.html',
      jp: 'http://kangol.jp/store/products/detail.php?product_id=746'
    },
    disk: 'https://hardwax.com/53569/move-d-feat-dj-late/workshop-02/'
  },
  'minimal-wave': {
    hat: {
      en: 'http://www.kangolstore.com/bamboo-mowbray.html',
      jp: 'http://kangol.jp/store/products/detail.php?product_id=663',
      kr: 'http://www.kangolkorea.com/product/detail.html?product_no=1753&cate_no=29&display_group=1'
    },
    disk: 'http://minimalwave.com/releases/release/h.s.t.a.-lp/'
  },
  plant: {
    hat: {
      en: 'http://www.kangolstore.com/bamboo-adjustable-spacecap.html',
      jp: 'http://kangol.jp/store/products/detail.php?product_id=722',
      kr: 'http://www.kangolkorea.com/product/detail.html?product_no=1744&cate_no=28&display_group=1'
    },
    disk: 'http://plantrecords.shop-pro.jp/?pid=89420262'
  },
  soundway: {
    hat: {
      en: 'http://www.kangolstore.com/british-peebles.html',
      jp: 'http://kangol.jp/store/products/detail.php?product_id=737'
    },
    disk: 'http://www.soundwayrecords.com/product/sndwcd062-sierra-leone-in-1970s-usa'
  },
};


/** WEBPACK FOOTER **
 ** ./src/playlists/product-links.jsx
 **/